export function toCoords(point: { lat: number; lng: number }): string {
  return `${point.lat.toFixed(6)},${point.lng.toFixed(6)}`
}
